// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// css
import '../../styles/components/common/DonutSliceChart.scss';


const DonutSliceChart = ({
  progressColor,
  outlineColor,
  offset,
  value,
  total,
  strokeWidthPercent = 2,
  fontSize = 16
}) => {

  const rootStyle = {
    borderRadius: '100%',
    position: 'relative',
    width: radius,
    height: radius
  };

  const classNames = classnames({
    'donut-slice-chart': true
  });

  const radius = 100;
  const diameter = radius * 2;
  const circle = Math.PI * diameter;
  const rotationDegrees = 180 + (360 * (offset / total));

  const adjustedRadius = radius - (radius * (strokeWidthPercent / 100));

  return (
    <div style={rootStyle} className={classNames}>
      <svg
        id='svg'
        viewBox={`0 0 ${diameter} ${diameter}`}
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g transform={`translate(${radius}, ${radius})`}>
          <circle
            className='donut-slice-chart__outline'
            r={adjustedRadius}
            fill='transparent'
            style={{
              stroke: outlineColor,
              strokeWidth: `${strokeWidthPercent}%`
            }}
          />
          <circle
            className='donut-slice-chart__progress'
            r={adjustedRadius}
            fill='transparent'
            transform={`rotate(${rotationDegrees.toFixed(2)})`}
            strokeDasharray={circle}
            style={{
              strokeDashoffset: circle * (1 - (value / total)),
              stroke: progressColor,
              strokeWidth: `${strokeWidthPercent}%`
            }}
          />
        </g>
      </svg>
      <div
        className='donut-slice-chart__content'
        style={{
          fontSize
        }}
      >
        {value}
      </div>
    </div>
  );
};

DonutSliceChart.propTypes = {
  outlineColor: PropTypes.string.isRequired,
  progressColor: PropTypes.string.isRequired,
  offset: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  strokeWidthPercent: PropTypes.number,
  fontSize: PropTypes.number
};

export default DonutSliceChart;



// WEBPACK FOOTER //
// ./src/components/common/DonutSliceChart.js